import PropTypes from "prop-types";
import { Link } from "gatsby";
import React, { useState, useEffect } from "react";
import styles from "./header.module.scss";
import { MdMenu } from "react-icons/md";
import classNames from "classnames";

const Header = ({ siteTitle }) => {
  const [isToggleOn, setIsToggleOn] = useState(false);

  const handleClick = () => {
    setIsToggleOn(!isToggleOn);
  };

  const [isSticky, setSticky] = useState(false);

  function setStickyHeader() {
    if (window.scrollY > 1) {
      setSticky(true);
    } else {
      setSticky(false);
    }
  }

  useEffect(() => {
    window.addEventListener("scroll", setStickyHeader);
  });

  return (
    <header
      className={classNames(styles.header, isSticky ? styles.stickyHeader : "")}
    >
      <div className={styles.container}>
        <div className={styles.logo}>
          <Link to="/">{siteTitle}</Link>
        </div>
        <div
          className={styles.burgerMenu}
          onClick={handleClick}
          onKeyDown={handleClick}
        >
          <MdMenu />
        </div>

        <nav
          className={classNames(
            styles.navigation,
            isToggleOn ? styles.openMenu : ""
          )}
        >
          <Link to="/benefits" activeClassName={styles.active}>
            Benefits
          </Link>
          <Link to="/features" activeClassName={styles.active}>
            Features
          </Link>
          <Link to="https://app.firesmarthub.ca/login" target="_blank">
            Login
          </Link>
          <a href="mailto:contact@firesmarthub.ca" className={styles.signup}>
            Join Us
          </a>
        </nav>
      </div>
    </header>
  );
};

Header.propTypes = {
  siteTitle: PropTypes.string,
};

Header.defaultProps = {
  siteTitle: ``,
};

export default Header;
